import React from 'react';

import { MessageTypeEnum, SectionMessagesEnum } from 'app/shared/enums';
import { Alert } from 'app/components/Alert';
import { useClearCalculationForm } from 'app/shared/hooks/useClearCalculationForm';

import { useStyles } from './EnterVehicleDataManuallyMessageBox.styles';

function EnterVehicleDataManuallyMessageBox() {
  const classes = useStyles();
  const { clearForm } = useClearCalculationForm();

  return (
    <>
      <div className={classes.root}>
        <Alert
          text={
            <div>
              <strong>{SectionMessagesEnum.VehicleNotFound1}</strong>
              <br />
              {SectionMessagesEnum.VehicleNotFound2}
              <button
                aria-label="Rozpocznij od nowa"
                className={classes.button}
                onClick={clearForm}
                type="button"
              >
                {SectionMessagesEnum.VehicleNotFound3}
              </button>
              .
            </div>
          }
          type={MessageTypeEnum.Warning}
        />
      </div>
    </>
  );
}

export default EnterVehicleDataManuallyMessageBox;
